export default __webpack_public_path__ + "static/media/gifchat5.6183f4bd.gif";